

/** Profile */
export const setApiAlert = (payload) => {
    return {
        type: "SET_API_ALERT",
        payload
    }
};